<div class="chart-wrapper">
    <h4 class="chart-header">{{name}}</h4>
    <p *ngFor="let value of data; let i = index;" class="row_versus"> {{value + " / " + max + " " + labels}}</p>
  </div>
